import * as React from 'react'
import { cva, type VariantProps } from 'class-variance-authority'
import { cn } from '@/lib/utils'

const textVariants = cva('font-sans', {
  variants: {
    size: {
      xs:   'text-xs leading-6',
      sm:   'text-sm leading-6',
      base: 'text-[15px] leading-[1.75]',
      lg:   'text-[17px] leading-[1.75]',
      xl:   'text-[20px] leading-[1.65]',
    },
    tone: {
      primary: 'text-text-primary',
      muted:   'text-text-muted',
      subtle:  'text-text-subtle',
    },
    weight: {
      regular: 'font-normal',
      medium:  'font-medium',
      semibold:'font-semibold',
    },
  },
  defaultVariants: { size: 'base', tone: 'primary', weight: 'regular' },
})

export interface TextProps
  extends React.HTMLAttributes<HTMLParagraphElement>,
    VariantProps<typeof textVariants> {
  as?: 'p' | 'span' | 'div'
}

export const Text = React.forwardRef<HTMLParagraphElement, TextProps>(
  ({ className, size, tone, weight, as = 'p', ...props }, ref) => {
    const Comp = as as 'p'
    return (
      <Comp
        ref={ref}
        className={cn(textVariants({ size, tone, weight }), className)}
        {...props}
      />
    )
  },
)
Text.displayName = 'Text'
